"use client";

import { useTranslation } from "react-i18next";
import { MobileMenu } from "@/data/types";
import Image from "next/image";
import giftCardIcon from "@/images/icons/gift-card.svg";
import blogIcon from "@/images/icons/blog.svg";
import faqIcon from "@/images/icons/faq.svg";
import aboutUsIcon from "@/images/icons/aboutus.svg";
import contactIcon from "@/images/icons/contact.svg";
import agendaIcon from "@/images/icons/agenda.svg";

export const useMoreMenu = (): MobileMenu[] => {
  const { t } = useTranslation("guydeez");

  return [
    { 
      href: "/guide-missions", 
      name: t("menu_guide_dashboard"), 
      description: t("menu_guide_dashboard_description"), 
      icon: () => <Image src={agendaIcon} alt={t("menu_guide_dashboard")} width={24} height={24} /> 
    },
   /* { 
      href: "/gift-cards", 
      name: t("menu_gift_cards"), 
      description: t("menu_gift_cards_description"), 
      icon: () => <Image src={giftCardIcon} alt="Gift Card" width={24} height={24} /> 
    },
    { 
      href: "/blog", 
      name: t("menu_blog"), 
      description: t("menu_blog_description"), 
      icon: () => <Image src={blogIcon} alt="Blog" width={24} height={24} /> 
    },*/
    { 
      href: "/faq", 
      name: t("menu_faq"), 
      description: t("menu_faq_description"), 
      icon: () => <Image src={faqIcon} alt="FAQ" width={24} height={24} /> 
    },
    { 
      href: "/about", 
      name: t("menu_about"), 
      description: t("menu_about_description"), 
      icon: () => <Image src={aboutUsIcon} alt="About" width={24} height={24} /> 
    },
    { 
      href: "/contact", 
      name: t("menu_contact_us"), 
      description: t("menu_contact_description"), 
      icon: () => <Image src={contactIcon} alt="Contact" width={24} height={24} /> 
    },
  ];
};